import { Skeleton } from '@mui/material';
const RTMSelectedAndTableSkeleton = () => {
  return (
    <div style={{ flex: 1, padding: '0 0 20px 20px', boxSizing: 'border-box' }}>
      {/* Selected Products Section */}
      <div style={{ marginBottom: '15px' }}>
        <Skeleton variant='text' width={150} height={30} style={{ marginBottom: '10px' }} />

        {/* Product Counters */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '20px', maxWidth: '50%' }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={`counter-${i}`} variant='rectangular' width='100%' height={24} style={{ borderRadius: '5px' }} />
          ))}
        </div>
      </div>

      {/* Devices Table */}
      <div style={{ marginBottom: '10px' }}>
        {/* Column Headers */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '220px 90px 150px 180px 150px',
            gap: '10px',
            padding: '10px 0',
          }}
        >
          <Skeleton variant='text' width='90%' height={25} />
          <Skeleton variant='text' width='70%' height={25} />
          <Skeleton variant='text' width='90%' height={25} />
          <Skeleton variant='text' width='95%' height={25} />
          <Skeleton variant='text' width='75%' height={25} />
        </div>
      </div>

      {/* Table Rows */}
      {Array.from({ length: 5 }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          style={{
            display: 'grid',
            gridTemplateColumns: '220px 90px 150px 180px 150px',
            gap: '10px',
            padding: '15px 0',
            borderTop: '1px solid #EBEBEB',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
            <Skeleton variant='circular' width={10} height={10} style={{ position: 'absolute', top: '5px', left: '0' }} />
            <Skeleton variant='rectangular' width={30} height={30} style={{ marginLeft: '20px', borderRadius: '3px' }} />
            <div style={{ marginLeft: '10px' }}>
              <Skeleton variant='text' width={150} height={20} style={{ marginBottom: '3px' }} />
              <Skeleton variant='text' width={130} height={15} />
            </div>
          </div>
          <Skeleton variant='rectangular' width={60} height={25} style={{ borderRadius: '3px' }} />
          <Skeleton variant='text' width={120} height={20} />
          <div>
            <Skeleton variant='text' width={150} height={20} style={{ marginBottom: '3px' }} />
            <Skeleton variant='text' width={130} height={15} />
          </div>
          <Skeleton variant='text' width={120} height={20} />
        </div>
      ))}
    </div>
  );
};

export default RTMSelectedAndTableSkeleton;
